module.exports = __webpack_public_path__ + "img/mrtp.64eaff1b.png";